<template>
  <div class="player">
    <video-player :options="videoOptions" />
  </div>
</template>
<script lang="ts">
import store from '@/store';
import { ref, watch } from '@vue/composition-api';
import {
  BForm,
  BFormGroup,
  BFormInput,
  BButton,
  BFormCheckbox,
  BFormCheckboxGroup,
} from 'bootstrap-vue';
import { showToast, useRouter } from '@core/utils/utils';
import VideoPlayer from './VideoJsPlayer.vue';

export default {
  components: {
    BFormGroup,
    BFormInput,
    BButton,
    BFormCheckbox,
    BFormCheckboxGroup,
    VideoPlayer,
  },
  props: {
    itemView: {
      type: Object,
      default: null,
    },
  },

  setup(props, context) {
    const videoOptions = ref({
      autoplay: true,
      controls: true,
      preload: true,
      fluid: true,
      sources: [],
    });
    if (Object.keys(props.itemView).length > 0) {
      videoOptions.value.sources.push({
        src: props.itemView.link,
        type: 'application/x-mpegURL',
      });
    }
    return {
      videoOptions,
    };
  },
};
</script>
